import { API_URL } from '../config/app';

// URL de l'image par défaut
export const DEFAULT_IMAGE = `${API_URL}/api/default-image`;

/** Logo affiché à la place d’une photo manquante (cartes experts, marqueurs carte) — pas le placeholder rose API. */
export const EXPERT_AVATAR_FALLBACK = '/images/logo-image-blanc.png';

function isExpertProfilePlaceholder(path: string | null | undefined): boolean {
  const normalized = (path || '').trim().replace(/\\/g, '/');
  if (!normalized) return true;
  if (normalized === '/api/default-image') return true;
  const lower = normalized.toLowerCase();
  if (lower.includes('default-profile') || lower.includes('default-avatar')) return true;
  if (lower === '/images/default-profile.png') return true;
  if (lower.startsWith('/profiles/')) return true;
  return false;
}

/**
 * Avatar expert pour cartes et carte Google : logo si pas de vraie photo, sinon même résolution que {@link getImageUrl}.
 */
export function getExpertAvatarUrl(path: string | null | undefined): string {
  if (isExpertProfilePlaceholder(path)) {
    return EXPERT_AVATAR_FALLBACK;
  }
  return getImageUrl(path);
}

/** URL absolue pour l’icône Google Maps (évite les chemins relatifs mal résolus par l’API). */
export function resolveMapMarkerIconUrl(url: string): string {
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return new URL(url.startsWith('/') ? url : `/${url}`, window.location.origin).href;
  }
  return url;
}

/**
 * Construit l'URL affichable d'une image de profil (chemins relatifs → API `/api/static`, comme la carte / couverture).
 * Une seule logique pour toute l'app : évite les écarts entre `/api/images/...` et `/api/static?path=...`.
 */
export const getImageUrl = (path: string | null | undefined): string => {
  const normalized = (path || '').trim().replace(/\\/g, '/');
  if (!normalized) {
    return DEFAULT_IMAGE;
  }
  if (normalized === '/api/default-image') {
    return DEFAULT_IMAGE;
  }
  if (
    normalized.toLowerCase().includes('default-profile') ||
    normalized.toLowerCase().includes('default-avatar') ||
    normalized === '/images/default-profile.png'
  ) {
    return DEFAULT_IMAGE;
  }
  if (normalized.toLowerCase().startsWith('/profiles/')) {
    return DEFAULT_IMAGE;
  }
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized;
  }
  if (normalized.startsWith('/uploads/')) {
    return `${API_URL}/api/images${normalized}`;
  }
  if (normalized.startsWith('/')) {
    return `${API_URL}${normalized}`;
  }
  return normalized;
};
